import { useEffect, useState } from 'react';
import { sign } from '@tsndr/cloudflare-worker-jwt';
import { stagesPointingToRSProd, rsEndpointList } from '../constants/lists'
import awsconfig from '../aws-exports';

const payload = {
    sub: 'placeholder-subject', //this is not consequential as it comes to the current implementation of the RS authorizer. thus the values
    iss: 'placeholder-issuer',
    allowedPages: 'receiptScanner',
    secret: 'placeholder-secret',
    iat: Math.floor(Date.now() / 1000),
};

export const determineRSEndpoint = () => {
    const stageBucket = awsconfig["aws_user_files_s3_bucket"];
    const stage = stageBucket.endsWith('-production-it')
        ? 'production-it'
        : stageBucket.slice(stageBucket.lastIndexOf('-') + 1);
    return stagesPointingToRSProd.includes(stage) ?
    rsEndpointList.prod :
    rsEndpointList.stage
}

export const useReceiptScannerToken = () => {
    const [rsToken, setRsToken] = useState<string | null>(null);

    useEffect(() => {
    const generateToken = async () => {
        const generatedToken = await sign(payload, 'placeholder-secret');
        console.log('Generated RS Token:', generatedToken);
        setRsToken(generatedToken);
    };
    generateToken();
    }, []);

    return rsToken;
}
